module.exports = __webpack_public_path__ + "static/media/comment-check.9acaa826.svg";